import React from "react"
import Img from "gatsby-image"

const ProductHeader = ({ headerImage, children }) => {
  return (
    <div className="product__header">
      <p className="product__header-text">{children}</p>
      <Img
        imgStyle={{ objectFit: "contain" }}
        className="product__header-image"
        fluid={headerImage || {}}
        alt=""
      />
    </div>
  )
}

export default ProductHeader
